import { FormControl, MenuItem, Select } from '@mui/material';

interface LegendPositionSelectProps {
  positions: any[];
  selectedPosition: any;
  onPositionChange: (value: string) => void;
}

export const LegendPositionSelect = ({
  positions,
  selectedPosition,
  onPositionChange,
}: LegendPositionSelectProps) => {
  return (
    <FormControl
      fullWidth
      size="small"
      style={{
        fontSize: '12px',
        borderRadius: '4px',
        paddingLeft: '4px',
        textAlign: 'left',
      }}
    >
      <Select
        label=""
        value={selectedPosition?.pos || ''}
        variant="outlined"
        onChange={(e) => onPositionChange(e.target.value)}
        sx={{
          fontSize: '12px',
          width: '99%',
          margin: '0 auto 0.5rem auto',
          backgroundColor: 'white',
          height: '1.5rem',
          color: '#404040',
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2bb9bb',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              '& .MuiMenuItem-root.Mui-selected': {
                backgroundColor: 'rgba(43, 185, 187, 0.1) !important',
              },
              '& .MuiMenuItem-root.Mui-selected:hover': {
                backgroundColor: 'rgba(43, 185, 187, 0.2) !important',
              },
            },
          },
        }}
      >
        {positions.map((position) => (
          <MenuItem
            value={position.pos}
            key={position.pos}
            sx={{
              padding: '2px 10px',
              fontSize: '12px',
            }}
          >
            {position.pos}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
